"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextElement = exports.getStylesForSizeGroup = void 0;

var _mediaQueries = require("../../media/mediaQueries");

var _constants = require("./constants");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _getResolvedWeight = require("../getResolvedWeight");

var _utils = require("./utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// Only fallback to the overflow prop of styles
// if the prop passed is undefined
var overflowIsTypeForSizeGroup = function overflowIsTypeForSizeGroup(sizeGroup) {
  return function (props, type) {
    return props.overflow === type || props.overflow === undefined && props[sizeGroup].overflow === type;
  };
}; // We can set letterSpacing to 0.0,
// so we need to check on that condition before
// falling back to the styles letterSpacing value


var getLetterSpacingForSizeGroup = function getLetterSpacingForSizeGroup(sizeGroup) {
  return function (props) {
    if (props.letterSpacing === 0 || props.letterSpacing === 0.0) {
      return 0;
    }

    return props.letterSpacing || props.letterSpacing === 0.0 || props[sizeGroup].letterSpacing;
  };
};

var getLineHeightForSizeGroup = function getLineHeightForSizeGroup(sizeGroup) {
  return function (props) {
    var lineHeight = props.lineHeight || props[sizeGroup].lineHeight;
    var size = props.size || props[sizeGroup].size; // In the legacy typography system, `lineHeight` values were
    // defined as relative multipliers (e.g. `em` values) that we then
    // calculated with the below rounding logic to be a desired pixel value.
    // In the modern system, the `lineHeight` values are represented in pixel
    // values, not relative multipliers. The below check sees if the size times
    // lineHeight is less than or equal to the `S10` line height, which is the largest
    // line height available in the legacy system.
    // If true, we can assume it is a legacy multiplier value and use the multiplication
    // and rounding logic to create a pixel equivalent for the lineHeight property.
    // If false, we can assume it is a modern value, and pass back the original value.

    if (size > lineHeight && size * lineHeight <= size * _constants.LineHeights.S10) {
      var MULTIPLE_TO_ROUND_TO = 2; // We round our lineHeights to the nearest 4pt
      // multiple—ensures that our vertical rhythm is
      // more consistent paired with our spacing values

      return Math.round(MULTIPLE_TO_ROUND_TO * Math.round(size * lineHeight / MULTIPLE_TO_ROUND_TO));
    }

    return lineHeight;
  };
};

var getDecorationForSizeGroup = function getDecorationForSizeGroup(sizeGroup) {
  return function (props) {
    var decorationVal = '';
    var decoration = props.textDecoration || props[sizeGroup].textDecoration;
    var decorationColor = props.themeDecorationColor;

    if (Array.isArray(decoration)) {
      decorationVal = decoration.join(' ');
    } else {
      decorationVal = decoration;
    }

    if (decorationVal && decorationVal.indexOf(_constants.TextDecorations.None) > -1) {
      return _constants.TextDecorations.None;
    }

    if (decorationColor) {
      decorationVal = "".concat(decorationVal, " ").concat(decorationColor);
    }

    return decorationVal;
  };
};

var getWeightForSizeGroup = function getWeightForSizeGroup(sizeGroup) {
  return function (props) {
    var specifiedWeight = props.weight || props[sizeGroup].weight;
    return (0, _getResolvedWeight.getResolvedWeight)(props.themeFontFamily, specifiedWeight);
  };
};

var getOverrideOrStyleForSizeGroup = function getOverrideOrStyleForSizeGroup(sizeGroup) {
  return function (property) {
    return function (props) {
      return props[property] || props[sizeGroup][property];
    };
  };
};
/**
 * getStylesForSizeGroup
 *  Defines a CSS fragment with typography styles
 *  based on the set needed for the media query.
 *
 * @argument sizeGroup:
 * Defines what group of styles in props to generate
 * a CSS fragment with.
 */


var getStylesForSizeGroup = function getStylesForSizeGroup(sizeGroup) {
  var getOverrideOrStyle = getOverrideOrStyleForSizeGroup(sizeGroup);
  var getLineHeight = getLineHeightForSizeGroup(sizeGroup);
  var getWeight = getWeightForSizeGroup(sizeGroup);
  var getLetterSpacing = getLetterSpacingForSizeGroup(sizeGroup);
  var getTextDecoration = getDecorationForSizeGroup(sizeGroup);
  var overflowIsType = overflowIsTypeForSizeGroup(sizeGroup);
  return (0, _styledComponents.css)(["font-size:", "px;font-family:", ";font-weight:", ";line-height:", "px;letter-spacing:", "ch;text-transform:", ";text-decoration:", ";color:", ";text-align:", ";margin:0;padding:0;display:", ";font-variant-ligatures:no-common-ligatures;", ";", ";"], getOverrideOrStyle('size'), function (props) {
    return (0, _utils.returnFontFamilyValues)(props.themeFontFamily)[getOverrideOrStyle('family')(props)];
  }, getWeight, getLineHeight, getLetterSpacing, getOverrideOrStyle('textTransform'), getTextDecoration, function (props) {
    return props.textColor;
  }, getOverrideOrStyle('textAlign'), function (props) {
    return props.display;
  }, function (props) {
    return overflowIsType(props, _constants.Overflows.BreakWord) && (0, _styledComponents.css)(["hyphens:auto;word-wrap:break-word;"]);
  }, function (props) {
    return overflowIsType(props, _constants.Overflows.Truncate) && (0, _styledComponents.css)(["max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;", ";"], props.maxLines > 1 && "\n            display: -webkit-box;\n            -webkit-line-clamp: ".concat(props.maxLines, ";\n            -webkit-box-orient: vertical;\n            max-height: ").concat(getLineHeight(props) * props.maxLines, "px;\n            white-space: normal;\n          "));
  });
};

exports.getStylesForSizeGroup = getStylesForSizeGroup;

var TextElement = _styledComponents["default"].span.withConfig({
  displayName: "styles__TextElement",
  componentId: "sc-1jrzcv7-0"
})(["", " @media (min-width:", "px){", ";}", " ", " ", " ", ""], getStylesForSizeGroup('styles'), _mediaQueries.Breakpoints.Mobile + 1, function (props) {
  // Only used in the non-legacy system (from `StyledBaseText`
  // ), these sets of styles are used when DesktopWidth values
  // are defined in the given theme's TextStyle semantic. We want
  // to apply these four potential properties that are defined
  // in the theme for > Breakpoint.Mobile viewports, but we still
  // want to honor direct API prop overrides when they are defined.
  return props.themeDesktopOverrideValues && (0, _styledComponents.css)(["", ";", ";", ";", ";"], props.themeDesktopOverrideValues.lineHeight && "line-height: ".concat(props.lineHeight || props.themeDesktopOverrideValues.lineHeight, "px;"), props.themeDesktopOverrideValues.size && "font-size: ".concat(props.size || props.themeDesktopOverrideValues.size, "px;"), props.themeDesktopOverrideValues.weight && "font-weight: ".concat((0, _getResolvedWeight.getResolvedWeight)(props.themeFontFamily, props.weight || props.themeDesktopOverrideValues.weight), ";"), props.themeDesktopOverrideValues.letterSpacing && "letter-spacing: ".concat(props.letterSpacing || props.themeDesktopOverrideValues.letterSpacing, "ch;"));
}, function (props) {
  return props.wideScreenStyles && _mediaQueries.Media.WideScreen(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), getStylesForSizeGroup('wideScreenStyles'));
}, function (props) {
  return props.desktopStyles && _mediaQueries.Media.Desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n  "])), getStylesForSizeGroup('desktopStyles'));
}, function (props) {
  return props.tabletStyles && _mediaQueries.Media.Tablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n  "])), getStylesForSizeGroup('tabletStyles'));
}, function (props) {
  return props.mobileStyles && _mediaQueries.Media.Mobile(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n  "])), getStylesForSizeGroup('mobileStyles'));
});

exports.TextElement = TextElement;